const $ = jQuery

export default class MenuTracker {
    /**
     * Constructor for MenuTracker
     * @param {Object} options - Configuration options for the MenuTracker
     * @param {string} options.wrapperSelector - Selector for the main navigation wrapper (default: '#main-nav')
     * @param {string} options.menuSelector - Selector for the main menu (default: '#main-menu')
     * @param {number} options.padding - Padding for the menu tracker (default: 8)
     */
    constructor({ wrapperSelector = '#main-nav', menuSelector = '#main-menu', padding = 8 } = {}) {
        this.$wrapper = $(wrapperSelector)
        this.$menu = this.$wrapper.find(menuSelector)
        this.padding = padding

        this.init()
    }

    /**
     * Initialize the menu tracker
     */
    init() {
        this.resetMenuTracker()
        $(window).on('resize', () => this.resetMenuTracker())
        this.$menu.on(
            'mouseenter mouseleave focusin focusout',
            '.nav-link',
            { nav: this.$wrapper },
            (event) => this.updateMenuTracker(event)
        )
    }

    /**
     * Reset the menu tracker to the active link
     */
    resetMenuTracker() {
        const $activeLink = this.$wrapper.find('ul .active > .nav-link')

        if ($activeLink.length) {
            const $menuTracker = this.$wrapper.find('.menu-tracker')
            const $line = $menuTracker.find('.line')

            if ($line.hasClass('fit-text')) {
                const left =
                    $activeLink.offset().left + ($activeLink.outerWidth() - $activeLink.width()) / 2
                $menuTracker.css('left', left)
                $line.css('width', $activeLink.width())
            } else {
                $menuTracker.css('left', $activeLink.offset().left)
                $line.css('width', $activeLink.outerWidth())
            }

            if ($menuTracker.data('top') === 'auto') {
                $menuTracker.css(
                    'top',
                    $activeLink[0].offsetTop + $activeLink[0].offsetHeight - this.padding
                )
            }

            $menuTracker.addClass('active')
        }
    }

    /**
     * Update the menu tracker based on the current event
     * @param {Event} event - The event object
     */
    updateMenuTracker(event) {
        const $this = $(event.currentTarget)
        const $menuTracker = this.$wrapper.find('.menu-tracker')
        const $line = $menuTracker.find('.line')

        if (event.type === 'mouseenter' || event.type === 'focusin') {
            if ($line.hasClass('fit-text')) {
                const left = $this.offset().left + ($this.outerWidth() - $this.width()) / 2
                $menuTracker.css('left', left)
                $line.css('width', $this.width())
            } else {
                $menuTracker.css('left', $this.offset().left)
                $line.css('width', $this.outerWidth())
            }

            if ($menuTracker.data('top') === 'auto') {
                $menuTracker.css('top', $this[0].offsetTop + $this[0].offsetHeight - this.padding)
            }

            $menuTracker.addClass('active')
        } else {
            $menuTracker.removeClass('active')
            this.resetMenuTracker()
        }
    }
}
